import {Button} from '@tkww/orion-web-ds-action';
import {TextBody} from '@tkww/orion-web-ds-text';
import {Modal} from '@tkww/orion-web-ds-dialog';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './ErrorModal.scss';

const ErrorModal = ({error, isOpen, close}) => {
  const {status, message} = error;
  const determineErrorBody = () =>
    status === 422
      ? message
      : "We're having trouble adding that gift. Please try again.";

  return (
    isOpen && (
      <Modal className={styles.wrapper} animation={false} onClose={close}>
        <header>
          <h1 className={styles.header}>Oops!</h1>
        </header>
        <TextBody size="md" className={styles.body}>
          {determineErrorBody()}
        </TextBody>
        <Button size="lg" onClick={close}>
          Got It
        </Button>
      </Modal>
    )
  );
};

ErrorModal.propTypes = {
  error: PropTypes.shape({
    status: PropTypes.number,
    message: PropTypes.string,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default ErrorModal;
